import { RowProps } from './types';

export default function Row({ data }: RowProps) {
  return (
    <tr>
      {data.map((str: string, i: number) => {
        const key = `${str}${i}`;

        return str ? <td key={key}>{str}</td> : <td key={key} />;
      })}
    </tr>
  );
}
